import React, { useState } from 'react';
import './input-number.scss';

const InputNumber = props => {

    const { onChange, value, maxValue } = props;
    const [quantity, setQuantity] = useState(value);

    const handleOnchange = (data) => {
        setQuantity(data);
        onChange(data);
    }


    return (
        <div className="f-input-number">
            <span
                className="f-icon-left"
                onClick={(e) => { e.preventDefault(); handleOnchange((quantity >= 2) ? quantity - 1 : quantity) }}>-</span>
          {quantity < maxValue && (
            <span
              className="f-icon-right"
              onClick={(e) => { e.preventDefault(); handleOnchange((quantity < maxValue) ? quantity + 1 : quantity) }}>+</span>
          )}

            <input
                className="f-input-number-container"
                type="number"
                readOnly="readonly"
                value={quantity}
            />
        </div>
    )
}

export default InputNumber;
